var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('multiselect',{staticClass:"form-control",attrs:{"options":_vm.meses,"track-by":"id","label":"nombre","searchable":false,"close-on-select":true,"show-labels":false,"placeholder":"Seleccione mes..."},model:{value:(_vm.modelo.idmes),callback:function ($$v) {_vm.$set(_vm.modelo, "idmes", $$v)},expression:"modelo.idmes"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }